import { Spinner, loadingMessage } from '@nrx/ui';
import type { JSX } from 'react';

import { DocsLayoutWide } from '../docs-shell/docs-layout.js';

const DEFAULT_MESSAGE = loadingMessage({ resource: 'page', operation: 'get' });

export interface PageFallbackProps {
  /** Visible loading copy. Defaults to "Loading page…". */
  message?: string;
}

/** Centred Spinner for Suspense boundaries already inside a docs layout. */
export function PageFallback({ message }: PageFallbackProps = {}): JSX.Element {
  return (
    <div className="flex justify-center py-12">
      <Spinner message={message ?? DEFAULT_MESSAGE} />
    </div>
  );
}

/**
 * Spinner inside the docs shell for routes whose page renders its own
 * `DocsLayoutWide` — keeps the topbar and sidebar mounted while the chunk loads.
 */
export function ShellPageFallback(props: PageFallbackProps = {}): JSX.Element {
  return (
    <DocsLayoutWide>
      <PageFallback {...props} />
    </DocsLayoutWide>
  );
}
